import React from 'react'
import PropTypes from 'prop-types'
import {ContentButtonNavigation, navButtonTypes} from '@/components/ui/carousel'
import {defaultContentNav} from './defaultConfig'

export const CustomCarouselContentNav = (props) => {
    const {
        buttonColor,
        inactiveButtonColor,
        buttonType = navButtonTypes.CircleButton,
        attributes
    } = props

    return (
        <ContentButtonNavigation
            buttonType={buttonType}
            buttonColor={buttonColor}
            {...(buttonType === navButtonTypes.FlatButton
                ? {
                      inactiveButtonColor
                  }
                : {})}
            {...attributes}
            data-testid="carouselContentNav-ContentButtonNavigation"
        />
    )
}

CustomCarouselContentNav.propTypes = {
    attributes: PropTypes.object,
    buttonColor: PropTypes.string,
    inactiveButtonColor: PropTypes.string,
    buttonType: PropTypes.string
}

export const CarouselContentNavDefinition = {
    component: CustomCarouselContentNav,
    name: 'CarouselContentNav',
    noWrap: true,
    defaultValue: defaultContentNav,
    inputs: [
        {
            name: 'buttonType',
            type: 'string',
            enum: Object.values(navButtonTypes),
            defaultValue: navButtonTypes.CircleButton
        },
        {
            name: 'buttonColor',
            type: 'color'
        },
        {
            name: 'inactiveButtonColor',
            type: 'color',
            showIf: `options.get('buttonType') === '${navButtonTypes.FlatButton}'`
        }
    ]
}
